<template>
  <div
    class="ma-3"
  >
    <div class="title">
      Payments
    </div>

    <div
      v-if="!sidebar_visible"
      class="sidebar-header left"
    >
      <v-icon
        color="primary"
        title="Show sidebar"
        @click="sidebar_visible = true"
      >
        mdi-eye
      </v-icon>
    </div>
    <div
      id="global-container"
      class="mt-3"
    >
      <v-list
        v-show="sidebar_visible"
        style="width: 300px; background: transparent; border-right: 1px solid #ddd"
      >
        <div class="sidebar-header">
          <v-icon
            color="primary"
            title="Hide sidebar"
            @click="sidebar_visible = false"
          >
            mdi-eye-off
          </v-icon>
        </div>
        <v-list-group
          no-action
          prepend-icon="mdi-cash-register"
          :value="
            [
              'payments-controls-index',
              'payments-controls-show',
              'payments-payments-index',
              'payments-payments-batches'
            ].includes(route)
          "
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>Payments management</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="{ name: 'payments-controls-index' }">
            <v-list-tile-content>
              <v-list-tile-title>Controls</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="{ name: 'payments-payments-index' }">
            <v-list-tile-content>
              <v-list-tile-title>Payments</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>

      <router-view />
    </div>
  </div>
</template>

<script>
import Auth from "@/plugins/auth";
import GlobalMixin from "@/mixins/global";
import BadgesMixin from "@/mixins/badges";

export default {
  mixins: [GlobalMixin, BadgesMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.route = to.name;
    });
  },
  data() {
    return {
      isAdmin: false,
      route: null,
      sidebar_visible: true
    };
  },
  mounted() {
    this.loadUser();
  },
  methods: {
    loadUser() {
      if (Auth.user.is_admin) {
        this.isAdmin = true;
      }
    }
  }
};
</script>
<style scoped lang="sass">
  #global-container
    flex-grow: 1
    width: 100%
    display: flex
    flex-direction: row
    justify-content: flex-start


  .sidebar-header
    display: flex
    flex-direction: row
    justify-content: flex-end

    &.left
      margin-top: 10px
      justify-content: flex-start

</style>
